var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorcus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 545,
    viewBox: "0 0 1600 545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-547.999 483.468C-548.103 470.049 -480.206 279.581 -313.839 132.352C-164.558 0.394604 111.135 -56.6842 377.399 73.6873C662.683 213.405 932.65 250.403 1162.02 239.376C1388.43 228.35 1560.29 146.586 1642.63 91.8561C1821.16 -26.3571 2005.98 74.8448 1883.34 241.057C1825.81 318.328 1728.44 332.201 1568.48 325.573C1401.28 318.645 1163.26 276.957 814.938 282.65C478.977 288.284 87.5507 341.324 -150.416 433.591C-403.699 531.887 -548.445 600.421 -547.999 483.468Z",
    fill: "#A60A24",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorcus);
export default __webpack_public_path__ + "static/media/vectorcus.dffe577cbbe906cb2bc838ea3cc374c5.svg";
export { ForwardRef as ReactComponent };